import React from 'react';
import { useMediaQuery } from 'react-responsive';
import { FilterDrawerMobile, FilterDrawerWrapper, FiltersContainer } from './Filters.style';
import Filters from './Filters';
import { device } from '../../styles/devices';
import useLockBodyScroll from '../../hooks/UI/useLockBodyScroll';
import useAnimations from '../../hooks/Animations/useAnimations';

interface FilterDrawerTypes {
  isFiltersOpen: boolean;
  isReachedEndOfContainer: boolean;
  setIsFiltersOpen: (arg: boolean) => void;
  isVehiclesLoading: boolean;
}

const FilterDrawer: React.FC<FilterDrawerTypes> = ({
  isFiltersOpen,
  isReachedEndOfContainer,
  isVehiclesLoading,
  setIsFiltersOpen,
}) => {
  const isLaptop = useMediaQuery({ query: device.laptop });
  useLockBodyScroll(isFiltersOpen && !isLaptop);

  const { filterDrawerAnimationDesktop, filterDrawerAnimationMobile, blackBackgroundAnimation } =
    useAnimations(isFiltersOpen);

  useLockBodyScroll(isFiltersOpen, isLaptop);

  return (
    <>
      {isLaptop ? (
        <FilterDrawerWrapper
          style={filterDrawerAnimationDesktop}
          className="filter-drawer-selector"
        >
          <Filters
            isFiltersOpen={isFiltersOpen}
            setIsFiltersOpen={setIsFiltersOpen}
            isLaptop={isLaptop}
            isReachedEndOfContainer={isReachedEndOfContainer}
            isVehiclesLoading={isVehiclesLoading}
          />
        </FilterDrawerWrapper>
      ) : (
        blackBackgroundAnimation(
          (props, item) =>
            item && (
              <FilterDrawerMobile style={props}>
                <FiltersContainer
                  style={filterDrawerAnimationMobile}
                  className="filter-drawer-selector"
                >
                  <Filters
                    isFiltersOpen={isFiltersOpen}
                    isVehiclesLoading={isVehiclesLoading}
                    setIsFiltersOpen={setIsFiltersOpen}
                    isLaptop={isLaptop}
                    isReachedEndOfContainer={isReachedEndOfContainer}
                  />
                </FiltersContainer>
              </FilterDrawerMobile>
            ),
        )
      )}
    </>
  );
};

export default FilterDrawer;
